// 创建pinia,在主程序入口中引用

import { createPinia } from "pinia";

const pinia = createPinia()

export default pinia